// extracted by mini-css-extract-plugin
export default {"outer-modal":"ContactModal_outer-modal__0Hb53","inner-modal":"ContactModal_inner-modal__FLYc0","lds-ring":"ContactModal_lds-ring__2UGTd"};